import Axios from 'axios';
import { LOCAL_STORAGE_TOKEN_NAME } from '../constants';

let baseURL = 'http://localhost:4000';
if (process.env.NODE_ENV === 'staging') {
    baseURL = 'https://tmh.iconicfnb.dev/proxy/';
}
if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://widget.temakinho.com/proxy/';
}

export const axiosInstance = Axios.create({
    baseURL
});

axiosInstance.interceptors.request.use(config => {
    if (config.url.indexOf('login') === -1) {
        const token = localStorage.getItem(LOCAL_STORAGE_TOKEN_NAME);
        config.headers['authorization'] = 'Bearer ' + token;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});


// WEBPACK FOOTER //
// ./src/api/apiConfig.js